import { MouseEvent } from "react";
import { Form } from "react-bootstrap";
import { createUUID } from "../../../shared/utils/utils";
import { noop } from "@/manager/utils";

export interface IProps {
  onClick(): void;
  checked?: boolean;
  label?: string;
  disabled?: boolean;
  required?: boolean;
}

function Checkbox({ onClick, checked, label, disabled, required }: IProps) {
  const handleClick = (e: MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Form.Check
      label={label}
      checked={checked}
      onClick={handleClick}
      onChange={noop}
      readOnly
      type="checkbox"
      id={createUUID()}
      disabled={disabled}
      required={required}
    />
  );
}

export default Checkbox;